import {Component, DoCheck, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService, SocialLoginService, UserService} from '../_services/index';
import {UserContext} from '../_context/user.context';
import {Constants} from '../shared/Helpers/constants';
import {SharedService} from '../shared/shared.service';
import * as moment from 'moment'
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {CookieService} from 'ngx-cookie';
import { AuthenticationMethodEnums, SocialProviderNameEnum} from '../enums/enums';
import {environment} from 'src/environments/environment';
import {ILastUserAccess, IOAuth2ConfigurationSimpleDto, IOrganisationInfo, ISamlConfigurationSimpleDto, ISearchRequest, ISimpleOrganisation} from '../shared/interfaces';
import Swal from 'sweetalert2';
import { Alert, AlertTypeEnum } from '../shared/Helpers/Alert';
import {AuthXService, WorkflowStep} from '@authx/authx-workflow-lib';
import { IPagination } from '../shared/interfaces/IPagination';
import { HelperFunctions } from '../shared/Helpers/helperFunctions';
import { Subject, debounceTime, distinctUntilChanged, switchMap, timer, takeUntil, of, tap } from 'rxjs';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import { AbleBaseLoginComponent } from './base-login.component';
import { Observable } from 'rxjs-compat';
import { FederatedAuthenticationService } from '../_services/federated-authentication.service';

@Component({
  moduleId: module.id,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent extends AbleBaseLoginComponent implements OnInit, OnDestroy, DoCheck {
  public pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    totalCount: 10,
    totalPages: 1
};
  public loadingOrganisationInfo: boolean = false;
  public checkFirstLogin: boolean = false;
  public passwordMode;
  public type;
  public passwordDaysExpire: number;
  public hasExpired: boolean;
  public controlPasswordExpired: boolean = false;
  public nextStep: boolean = false;
  public firstStep: boolean = true;
  public removeorganisationClicked = true;
  public LoggedInUserList: Array<ILastUserAccess>;
  public LoggedInUserListCheck: boolean;
  public logoPath: any = null;
  public passwordExpiry: boolean = false;
  public SocialProviderNameEnum: typeof SocialProviderNameEnum = SocialProviderNameEnum;
  public isFromUniqueUrl: boolean = false;

  private hostname: any;
  private firstLoginDataPeople: Date;
  private keyPressSubject = new Subject<string>();
  private timeSinceLastKeyPressSubject = new Subject<number>();

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected authenticationService: AuthenticationService,
    protected userService: UserService,
    protected userContext: UserContext,
    protected cookieService: CookieService,
    public sharedService: SharedService,
    protected socialLoginService: SocialLoginService,
    protected authXService: AuthXService,
    protected federatedAuthService: FederatedAuthenticationService
  ) {
    super(
      router,
      sharedService,
      authenticationService,
      cookieService,
      userContext,
      authXService,
      userService,
      federatedAuthService
    )
    this.userContext = new UserContext();
  }

  ngOnInit() {
    if (this.organisationId != undefined && this.organisationId != '') {
      this.router.navigateByUrl('/login/specific-place/' + this.organisationId)
    }

    if (localStorage.getItem('samlRequest')) {
      const samlRequest = JSON.parse(localStorage.getItem('samlRequest'));
      this.organisationId = samlRequest.orgIds
      this.selectedOrganisationName = 'placeholder'
    }
   this.initLastUsersAccess();
    // reset login status
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    localStorage.setItem('returnUrl', this.returnUrl);
    this.checkIfSamlRequest();
    this.getHostName();
    this.initProperites();
    this.checkIfUserIsAuthenticated();
    this.getLastUsersAccessed();

    const token = this.route.snapshot.queryParams['d'] || '';
    if (token != '') {
      localStorage.setItem('currentUser', atob(token));
      this.userContext = new UserContext();
      this.getPeopleData();
    }
  }

  ngOnDestroy() {
    this.sharedService.changeReturnUrl(this.returnUrl);
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        if(this.sharedService.Organisation.value != null && this.organisationList.length == 0){
          this.organisationList.push({
            name: this.sharedService.Organisation.value.organisationName,
            id: this.sharedService.Organisation.value.organisationId
          });
          this.isFromUniqueUrl = true;
          this.selectedOrganisationName = this.organisationList[0].name;
          this.organisationId = this.organisationList[0].id
        }
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }


  private getHostName() {
    if (this.returnUrl != undefined) {
      if (this.returnUrl.toString().trim().length > 1) {
        const parser = document.createElement('a');
        parser.href = this.returnUrl;
        this.hostname = parser.host;
      }
    }
  }

  private initProperites() {
    this.passwordMode = true;
    this.type = 'password';
    this.controlPasswordExpired = false;
    this.passwordExpiry = false;
  }

  private getLastUsersAccessed() {
    if (localStorage.getItem(Constants.localStorage_ListUsers) != undefined && localStorage.getItem(Constants.localStorage_ListUsers)?.length! > 0) {
      const LastUserLoggedIn: string = localStorage.getItem(Constants.localStorage_ListUsers);
      const usersArrayResult: Array<any> = JSON.parse(LastUserLoggedIn);
      this.LoggedInUserList = usersArrayResult.reverse().slice(Constants.minUsersList, Constants.maxUsersList)
      this.updateAvatars();
      this.LoggedInUserListCheck = true;
      this.firstStep = false;
    } else {
      this.LoggedInUserList = [];
      this.LoggedInUserListCheck = false;
      this.firstStep = true;
    }
  }

  private updateAvatars() {
    for (let i = 0; i < this.LoggedInUserList.length; i++) {
      this.userService.checkUsernameAuthenticationWithOrganisation(this.LoggedInUserList[i].username, this.organisationId).subscribe((data: any) => {
        this.LoggedInUserList[i].avatar = data.body.avatar;
        if (i == this.LoggedInUserList.length - 1) {
          this.sharedService.changeCurrentOrganisationId(this.organisationId);
          this.sharedService.changeUserAttemptedLogin(data.body.homeUserId);
          localStorage.removeItem(Constants.localStorage_ListUsers);
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.LoggedInUserList))
        }
      });
    }
  }

  protected handleUserLoginResponse = (user: any) => {
    if (localStorage.getItem(Constants.localStorage_currentUser)) {
      this.userContext = new UserContext();
      // if he is authenticated with username and password, and with 2fa if required, so if token is contextualized
      if (this.userContext.isAuthenticated && this.userContext.organisationID && this.userContext.userID) {
        // it is already contextualized
        if (this.userContext.userName === this.loginModel.username) {
          this.checkIfSamlRequestExistsInLocalStorage();
        } else {
          Alert.basicNotification(AlertTypeEnum.Warning, "Warning", `You are already signed in with another account "${this.userContext.userName}", at "${this.userContext.createdToken.toLocaleString()}"`);
          this.loading = false;
        }
      } else this.storeLoggedUser(user)

    } else this.storeLoggedUser(user)
    this.loading = false
  }

  public OnKeyPress(searchString: string) {
    const request: ISearchRequest = {
      searchString: searchString
    }
    if (searchString.length > 2 && !searchString.toLowerCase().startsWith('uni')) {
      this.searchInput$.next(request);
    }
    else {
      const stringToCheck = 'university of';
      if (searchString.toLowerCase().startsWith('uni') && searchString.length > stringToCheck.length + 4) {
        this.searchInput$.next(request);
      }
    }
  }

  protected onUsernameValidationResponse = (response: any, selectedOrganisation: ISimpleOrganisation = null) => {
    this.firstStep = true;
    this.selectedOrganisationName = selectedOrganisation.organisationName;
    this.checkAuthenticationMethod(response);
    this.loading = false
  }
  protected managedAuthenticationMethod = (response: any) => {
    this.nextStep = true;
    this.removeorganisationClicked = false;
    this.LastUserAccess.avatar = response.avatar;
    this.LastUserAccess.username = this.userNameValidated;
  }

  onKeyDown(event, isValid) {
    if (event.keyCode == 13) {
      if (this.nextStep && !this.isLiberateUser) {
        if (isValid) {
          this.onUserLogin();
        }
      } else {
        this.usernameValidation();
      }
    }
  }

  protected  getPeopleData = () => {
    const currentUser = new UserContext();
    if (currentUser.isAuthenticated) {
      this.userService.getPeopleById(currentUser.personID).subscribe({
        next: (res) => {
          this.peopleData = res.body;
          this.firstLoginDataPeople = this.peopleData.firstLoginDate;
          this.checkPasswordExpiry();
        },
        error: (err) => {
          if (err.status === 0) {
            this.checkFirstLogin = false;
            this.controlPasswordExpired = true;
            this.hasExpired = true;
            this.peopleData = {};
            this.passwordExpiry = true;

          } else if (err.status === 401) {
            if (err.error.errorCode === 1012) {
              this.checkFirstLogin = true;
            } else if (err.error.errorCode === 1010) {
              this.checkFirstLogin = false;
            }
            this.sharedService.storeFirstLoginForExpiryPassword(this.checkFirstLogin);
            this.controlPasswordExpired = true;
            this.hasExpired = true;
            this.peopleData = {};
            this.passwordExpiry = true;
          }
        }
      });
    }
  }

  // ToDo: replace current method with this one once the domain problem is fixed
  private contextualizeByOrganisationHostname() {
    // If no organisation was found contextualize token by user's home organisation
    this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
      const user = userData.body;
      const filterUser = user.filter(item => item.isHomeUser == true);
      this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
      this.sharedService.changeLoggedUserId(filterUser[0].id);
    });
  }

  // contextualize Token
  private contextualizeToken(organisationId: any) {
    this.userService.contextualizeToken(organisationId).subscribe({
      next: (data) => {
        if (data.status == 200) {
          const user = data.body;
          localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
          this.checkIfSamlRequestExistsInLocalStorage();
        }
      },
      error: (err) => {
        if (err.error.errorCode === 1016) {
          // 2fa required, but no configurations for 2fa
          this.getUserIdByErrorMsg(err.error.detailedMessage);
          this.router.navigateByUrl('/2FA-setup');
        }
        // 2fa required and code sent to the last configured method (sms/app)
        else if (err.error.errorCode === 1017) {
          const errMsg: string = err.error.detailedMessage;
          this.getUserIdByErrorMsg(errMsg);
          this.router.navigateByUrl('/2FA-authentication');
        }
        // 2fa required, but the setup of app not fully completed
        else if (err.error.errorCode === 1018) {
          this.getUserIdByErrorMsg(err.error.detailedMessage);
          // this.sharedService.changeAppSetupConfirmPending(true);
          this.router.navigateByUrl('/2FA-authentication');
        } else if (err.status === 422 && err.error.errorCode === 1006) {
          const currentUser = new UserContext();
          this.sharedService.setErrorMsg(err.error.detailedMessage);
          if (!this.sharedService.loggedUserId.value) {
            this.userService.getHomeUser(currentUser.personID).subscribe({
              next: (res) => {
                const userId = res.body.find(usr => usr.organisation.id == organisationId).id;
                if (userId) {
                  this.sharedService.changeLoggedUserId(userId)
                } else {
                  this.sharedService.changeLoggedUserId(this.peopleData.homeUser.id)
                }
              },
              error: (err) => {
                this.sharedService.changeLoggedUserId(this.peopleData.homeUser.id)
              },
              complete: () => {
                this.router.navigateByUrl('/2FA-authentication');
              }
            })
          } else {
            this.router.navigateByUrl('/2FA-authentication');
          }
        }
      }
    })
  }

  protected getUserIdByErrorMsg(errMsg: any) {
    const userId: string = errMsg.substr(errMsg.indexOf('\'') + 1, 36);
    this.sharedService.changeLoggedUserId(userId);
  }

  // check password exiry
  private checkPasswordExpiry() {
    // check if password expired date is less than 7 days.
    // Get the current date
    const todayDate = new Date();
    // Set start/end dates to a specified date
    const expiryDate = new Date(this.peopleData.passwordExpiryDate);

    // Compare the two dates
    const duration = Math.floor((Date.UTC(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate())
      - Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate())) / (1000 * 60 * 60 * 24));

    this.passwordDaysExpire = duration;

    if (this.passwordDaysExpire <= 7) {
      this.userService.checkPeopleLastAccess(this.peopleData.id).subscribe({
        next: (data) => {
          const checkLastAccess = data.body;

          if (checkLastAccess.shouldDisplayMessage) {
            if (duration <= 7 && duration > 2) {
              this.controlPasswordExpired = true;
              this.passwordExpiry = true;
              // show popup to reset password or to skip it
            } else if (duration <= 2) {
              if (duration <= 0) {
                this.controlPasswordExpired = true;
                this.hasExpired = true;
                this.passwordExpiry = true;
              } else {
                this.controlPasswordExpired = true;
                this.passwordExpiry = true;
              }
            } else {
              this.checkIfSamlRequestExistsInLocalStorage();
            }
          } else {
            if (duration <= 2) {
              if (duration <= 0) {
                this.controlPasswordExpired = true;
                this.hasExpired = true;
                this.passwordExpiry = true;
              } else {
                this.controlPasswordExpired = true;
                this.passwordExpiry = true;
              }
            } else {
              this.checkIfSamlRequestExistsInLocalStorage();
            }
          }
        },
        error: (err) => {
          console.log(err)
        }
      });
    } else {
      if (this.compareFirstLoginWithCurrentLoginDate(this.firstLoginDataPeople, this.currentloginDate)) {
        this.getOrganisationIdByUrl();
      } else {
        this.checkIfSamlRequestExistsInLocalStorage();
      }
    }
  }

  private compareFirstLoginWithCurrentLoginDate(firstLoginDate, currentLoginDate: string): boolean {
    return (firstLoginDate > currentLoginDate) ? true : false;
  }

  public getOrganisationIdByUrl() {
    if (this.hostname !== environment.default_return_url && ((this.returnUrl != undefined || this.returnUrl != null) && this.returnUrl != environment.default_return_url)) {
      this.getOrganisationIdByHomeUser();
    } else {
      this.getOrganisationIdByHomeUser();
    }
  }

  getOrganisationIdByHomeUser() {
    this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
      const filterUser = userData.body.filter(item => item.isHomeUser == true);
      this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
      this.sharedService.changeLoggedUserId(filterUser[0].id)
      this.checkIfSecurityQuestions(filterUser[0]);
    });
  }

  getUserByOrganisationId(organisationId: string) {
    this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
      const user = userData.body.find(usr => usr.organisation.id == organisationId);
      if (user && user.id) {
        this.sharedService.changeLoggedUserId(user.id)
        this.checkIfSecurityQuestions(user);
      } else {
        const homeUser = userData.body.find(item => item.isHomeUser == true)
        this.checkIfSecurityQuestions(homeUser);
      }
    });
  }

  public checkIfSecurityQuestions(userObj: any) {
    if (this.sharedService.currentOrganisationId.value) {
      this.userService.getSecurityQuestions(userObj.userType.id, this.sharedService.currentOrganisationId.value).subscribe((resp) => {
        this.checkIfSamlRequestExistsInLocalStorage();
      });
    }
  }

  public enterContextualisation() {
    if (this.sharedService.currentOrganisationId.value) {
      this.contextualizeToken(this.sharedService.currentOrganisationId.value);
    } else {
      if (this.hostname !== environment.default_return_url && ((this.returnUrl != undefined || this.returnUrl != null) && this.returnUrl != environment.default_return_url)) {
        this.contextualizeByOrganisationHostname();
      } else {
        this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
          const user = userData.body;
          const filterUser = user.filter(item => item.isHomeUser == true);
          this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
          this.sharedService.changeLoggedUserId(filterUser[0].id)
          this.contextualizeToken(filterUser[0].organisation.id);
        });
      }
    }
  }

  public passwordModeOn() {
    this.passwordMode = true;
    this.type = 'password';
  }

  public passwordModeOff() {
    this.passwordMode = false;
    this.type = 'text';
  }

  public onSkip() {
    this.passwordExpiry = false;
    this.checkIfSamlRequestExistsInLocalStorage();
  }

  public onReset() {
    this.passwordExpiry = false;
    this.router.navigate(['reset-password']);
  }

  public onUserFromList(user) {
    if (user != undefined || user != null) {
      this.loginModel.username = user;
      this.usernameValidation();
    }
  }

  public onRemoveAccount() {
    this.loginModel.username = null;
    this.nextStep = false;
    this.loading = false;
    this.loginModel.password = null;
  }

  public onRemoveOrganisation() {
    this.loginModel = {};
    this.nextStep = false;
    this.removeorganisationClicked = true;
    this.loading = false;
    this.sharedService.changeCurrentOrganisationId(null);
  }

  public onRemoveAccountFromList(user) {
    if (localStorage.getItem(Constants.localStorage_ListUsers) != undefined && localStorage.getItem(Constants.localStorage_ListUsers)?.length! > 0) {
      const LastUserLoggedIn = localStorage.getItem(Constants.localStorage_ListUsers);

      this.LoggedInUserList = JSON.parse(LastUserLoggedIn);
      ///check if exist;
      if (this.LoggedInUserList.filter(item => item.username == user).length > 0) {
        this.LoggedInUserList = this.LoggedInUserList.filter(item => item.username != user);

        if (this.LoggedInUserList.length == 0) {
          this.RemoveLastUserInit();
        } else {
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.LoggedInUserList));
          const LastUserLogged = localStorage.getItem(Constants.localStorage_ListUsers);
          this.LoggedInUserList = JSON.parse(LastUserLogged);
          this.LoggedInUserListCheck = true;
          this.firstStep = false;
        }
      }
    }
  }

  private RemoveLastUserInit() {
    localStorage.removeItem(Constants.localStorage_ListUsers);
    this.firstStep = true;
    this.LoggedInUserListCheck = false;
    this.controlPasswordExpired = false;
    this.LoggedInUserList = [];
  }

  public authenticateAsNewUser() {
    this.firstStep = true;
  }

  private checkIfSamlRequest() {
    if (this.route.snapshot.queryParams['SAMLRequest']) {
      let samlRequest = this.route.snapshot.queryParams['SAMLRequest'];
      let relayState = this.route.snapshot.queryParams['RelayState'];
      let tenant = this.route.snapshot.queryParams['tenant'];
      let orgIds = this.route.snapshot.queryParams['orgIds'];
      this.organisationId = orgIds
      let redirectUrl = this.route.snapshot.queryParams['redirectUrl'];
      let method = this.route.snapshot.queryParams['method'];
      let objectForLStorage = {
        samlRequest: samlRequest,
        relayState: relayState,
        tenant: tenant,
        orgIds: orgIds,
        redirectUrl: atob(redirectUrl),
        method: method
      };
      localStorage.setItem('samlRequest', JSON.stringify(objectForLStorage));
      this.router.navigateByUrl('/login');

    }
  }

  protected checkIfSamlRequestExistsInLocalStorage = () => {

    if (localStorage.getItem('samlRequest')) {
      let data = JSON.parse(localStorage.getItem('samlRequest'));
      localStorage.removeItem('samlRequest');
      let queryParam: string;
      queryParam = '?tenant=tenant1';
      if (localStorage.getItem(Constants.localStorage_currentUser)) {
        const token = JSON.parse(localStorage.getItem(Constants.localStorage_currentUser))
        queryParam+='&token='+token.token;
      }
      if (data.method == 'POST') {
        let bodyPost = 'SAMLRequest=' + encodeURIComponent(data.samlRequest) + '&RelayState=' + encodeURIComponent(data.relayState);
        if (data.orgIds != null && data.orgIds != '') {
          this.authenticationService.samlSsoRequest(data.redirectUrl, data.orgIds, 'POST', queryParam, bodyPost).subscribe({
            next: (data) => {
              this.openWindow(data);
              this.authenticationService.redirect(this.returnUrl);
            },
            error: () => {
              this.authenticationService.redirect(this.returnUrl);
            }
          })
        } else {
          this.authenticationService.samlSsoRequestWithoutOrg('POST', queryParam, bodyPost).subscribe({
            next: (data) => {
              this.openWindow(data)
              this.authenticationService.redirect(this.returnUrl);
            },
            error: (err) => {
              this.authenticationService.redirect(this.returnUrl);
            }
          })
        }
      } else {
        queryParam += '&SAMLRequest=' + encodeURIComponent(data.samlRequest) + '&RelayState=' + encodeURIComponent(data.relayState);
        if (data.orgIds != null && data.orgIds != '') {
          this.authenticationService.samlSsoRequest(data.redirectUrl, data.orgIds, 'GET', queryParam).subscribe({
            next: (data) => {
              this.openWindow(data);
              this.authenticationService.redirect(this.returnUrl);
            },
            error: (err) => {
              this.authenticationService.redirect(this.returnUrl);
            }
          })
        } else {
          this.authenticationService.samlSsoRequestWithoutOrg('POST', queryParam).subscribe({
            next: (data) => {
              this.openWindow(data);
              this.authenticationService.redirect(this.returnUrl);
            },
            error: (err) => {
              this.authenticationService.redirect(this.returnUrl);
            }
          })
        }
      }
    } else {
      if(HelperFunctions.IsEmptyOrUndefined(this.returnUrl))
        this.returnUrl = environment.default_return_url;
      this.authenticationService.redirect(this.returnUrl)
    }
  }

  private openWindow(data: HttpResponse<string>) {
    let markup: any = data.body;
    let wnd: any = window.open('about:blank', '');

    if (!wnd || wnd.closed || typeof wnd == 'undefined' || typeof wnd.closed == 'undefined') {
      let msg: any = ' <p> Your browser is blocking pop ups, please allow them and click here to be redirected</p>';
      Swal.fire({
        title: 'Allow popup',
        html: msg,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Click here',
        customClass: 'sweetalert-lg',
        width: '500px'
      }).then((result) => {
        var wnd: any = window.open('about:blank', '');
        wnd.document.write(markup);
        wnd.document.close();
        var win: any = window.open('about:blank', '_self');
        win.close();
        window.close();
      });
    } else {
      wnd.document.write(markup);
      wnd.document.close();
      window.close();
    }
  }

  public onLoginWithSocialClick(socialProviderName: String) {
    this.socialLoginService.socialLoginAuthorizationUrl(socialProviderName).subscribe((res: any) => {
      if (res) {
        window.location.href = res.toString();
      }
    });
  }



  public onOrgSelected = (org?: any) => {
    //check if the organisation selected/typed is part of organisations list
    let selected = org || this.organisationList.find(org => org.name.toLowerCase() === this.loginModel.organisation.toLowerCase());
    console.log(selected)
    if (selected) {
      this.selectedOrganisationName = selected.placeName || selected.name;
      this.getOrganisationInfo(selected?.id);
    } else {
      console.log('no such organizatiosn in orgList');
    }
  };



}
